module.exports = __webpack_public_path__ + "img/youtubeLogo.1c0eea39.svg";